import withMethods from "./withMethods";
import Running from "./Running.Strikezone";
import Testing from "./Testing.Strikezone";

import "./styles.scss";

export const RunningStrikezone = withMethods(Running);
export const TestingStrikezone = withMethods(Testing);
